import { useAuth } from '../hooks/useAuth';
import { useState } from 'react';

export default function SettingsPage() {
     const { user } = useAuth();
     const [activeTab, setActiveTab] = useState('profile');

     return (
          <div>
               <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Settings</h1>
               </div>

               <div className="row">
                    <div className="col-lg-3">
                         {/* Settings Navigation */}
                         <div className="card shadow mb-4">
                              <div className="card-body p-0">
                                   <nav className="nav nav-pills flex-column">
                                        <button
                                             className={`nav-link ${activeTab === 'profile' ? 'active' : ''}`}
                                             onClick={() => setActiveTab('profile')}
                                             style={{ textAlign: 'left', border: 'none', background: 'none' }}
                                        >
                                             <i className="fas fa-user mr-2"></i>
                                             Profile Settings
                                        </button>
                                        <button
                                             className={`nav-link ${activeTab === 'security' ? 'active' : ''}`}
                                             onClick={() => setActiveTab('security')}
                                             style={{ textAlign: 'left', border: 'none', background: 'none' }}
                                        >
                                             <i className="fas fa-lock mr-2"></i>
                                             Security
                                        </button>
                                        <button
                                             className={`nav-link ${activeTab === 'notifications' ? 'active' : ''}`}
                                             onClick={() => setActiveTab('notifications')}
                                             style={{ textAlign: 'left', border: 'none', background: 'none' }}
                                        >
                                             <i className="fas fa-bell mr-2"></i>
                                             Notifications
                                        </button>
                                        <button
                                             className={`nav-link ${activeTab === 'preferences' ? 'active' : ''}`}
                                             onClick={() => setActiveTab('preferences')}
                                             style={{ textAlign: 'left', border: 'none', background: 'none' }}
                                        >
                                             <i className="fas fa-cog mr-2"></i>
                                             Preferences
                                        </button>
                                   </nav>
                              </div>
                         </div>
                    </div>

                    <div className="col-lg-9">
                         {/* Profile Settings */}
                         {activeTab === 'profile' && (
                              <div className="card shadow mb-4">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Profile Information</h6>
                                   </div>
                                   <div className="card-body">
                                        <form>
                                             <div className="row">
                                                  <div className="col-md-6">
                                                       <div className="form-group">
                                                            <label htmlFor="userName">Full Name</label>
                                                            <input
                                                                 type="text"
                                                                 className="form-control"
                                                                 id="userName"
                                                                 defaultValue={user?.user_name || ''}
                                                            />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-6">
                                                       <div className="form-group">
                                                            <label htmlFor="userCode">User Code</label>
                                                            <input
                                                                 type="text"
                                                                 className="form-control"
                                                                 id="userCode"
                                                                 defaultValue={user?.user_code || ''}
                                                                 disabled
                                                            />
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="row">
                                                  <div className="col-md-6">
                                                       <div className="form-group">
                                                            <label htmlFor="email">Email Address</label>
                                                            <input
                                                                 type="email"
                                                                 className="form-control"
                                                                 id="email"
                                                                 defaultValue={user?.email || ''}
                                                            />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-6">
                                                       <div className="form-group">
                                                            <label htmlFor="role">Role</label>
                                                            <input
                                                                 type="text"
                                                                 className="form-control"
                                                                 id="role"
                                                                 defaultValue={user?.role || ''}
                                                                 disabled
                                                            />
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="form-group">
                                                  <label htmlFor="validity">Account Validity</label>
                                                  <input
                                                       type="text"
                                                       className="form-control"
                                                       id="validity"
                                                       defaultValue={user?.validity || ''}
                                                       disabled
                                                  />
                                             </div>
                                             <button type="submit" className="btn btn-primary">
                                                  <i className="fas fa-save mr-2"></i>
                                                  Save Changes
                                             </button>
                                        </form>
                                   </div>
                              </div>
                         )}

                         {/* Security Settings */}
                         {activeTab === 'security' && (
                              <div className="card shadow mb-4">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Security Settings</h6>
                                   </div>
                                   <div className="card-body">
                                        <form>
                                             <div className="form-group">
                                                  <label htmlFor="currentPassword">Current Password</label>
                                                  <input type="password" className="form-control" id="currentPassword" />
                                             </div>
                                             <div className="form-group">
                                                  <label htmlFor="newPassword">New Password</label>
                                                  <input type="password" className="form-control" id="newPassword" />
                                             </div>
                                             <div className="form-group">
                                                  <label htmlFor="confirmPassword">Confirm New Password</label>
                                                  <input type="password" className="form-control" id="confirmPassword" />
                                             </div>
                                             <button type="submit" className="btn btn-warning">
                                                  <i className="fas fa-key mr-2"></i>
                                                  Change Password
                                             </button>
                                        </form>

                                        <hr />

                                        <h6 className="font-weight-bold text-primary mb-3">Two-Factor Authentication</h6>
                                        <div className="custom-control custom-switch">
                                             <input type="checkbox" className="custom-control-input" id="twoFactorAuth" />
                                             <label className="custom-control-label" htmlFor="twoFactorAuth">
                                                  Enable Two-Factor Authentication
                                             </label>
                                        </div>
                                        <small className="text-muted">
                                             Add an extra layer of security to your account by enabling two-factor authentication.
                                        </small>
                                   </div>
                              </div>
                         )}

                         {/* Notifications Settings */}
                         {activeTab === 'notifications' && (
                              <div className="card shadow mb-4">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Notification Preferences</h6>
                                   </div>
                                   <div className="card-body">
                                        <div className="form-group">
                                             <h6 className="font-weight-bold">Email Notifications</h6>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="emailBadges" defaultChecked />
                                                  <label className="custom-control-label" htmlFor="emailBadges">
                                                       New badge awards
                                                  </label>
                                             </div>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="emailReports" defaultChecked />
                                                  <label className="custom-control-label" htmlFor="emailReports">
                                                       Monthly reports
                                                  </label>
                                             </div>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="emailUpdates" />
                                                  <label className="custom-control-label" htmlFor="emailUpdates">
                                                       System updates
                                                  </label>
                                             </div>
                                        </div>

                                        <div className="form-group">
                                             <h6 className="font-weight-bold">Push Notifications</h6>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="pushBadges" defaultChecked />
                                                  <label className="custom-control-label" htmlFor="pushBadges">
                                                       Badge progress updates
                                                  </label>
                                             </div>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="pushReminders" defaultChecked />
                                                  <label className="custom-control-label" htmlFor="pushReminders">
                                                       Training reminders
                                                  </label>
                                             </div>
                                        </div>

                                        <button type="submit" className="btn btn-primary">
                                             <i className="fas fa-save mr-2"></i>
                                             Save Preferences
                                        </button>
                                   </div>
                              </div>
                         )}

                         {/* Preferences Settings */}
                         {activeTab === 'preferences' && (
                              <div className="card shadow mb-4">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Application Preferences</h6>
                                   </div>
                                   <div className="card-body">
                                        <form>
                                             <div className="form-group">
                                                  <label htmlFor="language">Language</label>
                                                  <select className="form-control" id="language">
                                                       <option value="en">English</option>
                                                       <option value="es">Spanish</option>
                                                       <option value="fr">French</option>
                                                  </select>
                                             </div>
                                             <div className="form-group">
                                                  <label htmlFor="timezone">Timezone</label>
                                                  <select className="form-control" id="timezone">
                                                       <option value="utc">UTC</option>
                                                       <option value="est">Eastern Time</option>
                                                       <option value="pst">Pacific Time</option>
                                                       <option value="ist">India Standard Time</option>
                                                  </select>
                                             </div>
                                             <div className="form-group">
                                                  <label htmlFor="theme">Theme</label>
                                                  <select className="form-control" id="theme">
                                                       <option value="light">Light</option>
                                                       <option value="dark">Dark</option>
                                                       <option value="auto">Auto</option>
                                                  </select>
                                             </div>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="autoSave" defaultChecked />
                                                  <label className="custom-control-label" htmlFor="autoSave">
                                                       Enable auto-save
                                                  </label>
                                             </div>
                                             <div className="custom-control custom-checkbox">
                                                  <input type="checkbox" className="custom-control-input" id="compactMode" />
                                                  <label className="custom-control-label" htmlFor="compactMode">
                                                       Compact interface mode
                                                  </label>
                                             </div>
                                             <br />
                                             <button type="submit" className="btn btn-primary">
                                                  <i className="fas fa-save mr-2"></i>
                                                  Save Preferences
                                             </button>
                                        </form>
                                   </div>
                              </div>
                         )}
                    </div>
               </div>
          </div>
     );
}